import React, { Component } from 'react';
import { Link } from 'react-router-dom';
type ArtworkListProps = {
  artworks: string[];
  selectedArtwork: string | null;
  onSelect: (name: string) => void;
  onDelete: (name: string) => void;
};
export function ArtworkList({
  artworks,
  selectedArtwork,
  onSelect,
  onDelete
}: ArtworkListProps) {
  if (artworks.length === 0) {
    return <div className="text-gray-500 text-sm" data-id="element-7">
        No artworks added yet. Enter an artwork name above to get started.
      </div>;
  }
  return <div className="space-y-2" data-id="element-8">
      {artworks.map(artwork => <div key={artwork} className={`flex items-center justify-between p-3 rounded-md cursor-pointer transition-colors ${selectedArtwork === artwork ? 'bg-indigo-50 border border-indigo-200' : 'bg-white border border-gray-200 hover:border-indigo-200'}`} onClick={() => onSelect(artwork)} data-id="element-9">
          <span className="font-medium text-gray-800" data-id="element-10">{artwork}</span>
          <div className="flex items-center space-x-3" data-id="element-11">
            <Link to={`/view/${encodeURIComponent(artwork)}`} className="text-indigo-600 hover:text-indigo-800 text-sm" onClick={e => e.stopPropagation()} data-id="element-12">
              Share
            </Link>
            <button onClick={e => {
          e.stopPropagation();
          onDelete(artwork);
        }} className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-13">
              Delete
            </button>
          </div>
        </div>)}
    </div>;
}